import axios from 'axios';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

const Changepassword = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loaded, setLoaded] = useState(false);

  // State for password visibility
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoaded(true);

    const token = localStorage.getItem('token');
    try {
      await axios.post(
        `${apiUrl}/api/auth/change-password`,
        {
          oldPassword,
          newPassword,
        },
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success('Password updated successfully!');
      setOldPassword('');
      setNewPassword('');
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to update password.'
      );
    } finally {
      setLoaded(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleChangePassword}>
        {/* Old Password Field */}
        <div className="mt-3 m-lg-2">
          <label htmlFor="oldPassword">Old Password</label>
          <div className="input-group">
            <input
              type={showOldPassword ? 'text' : 'password'}
              className="form-control "
              id="oldPassword"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setShowOldPassword(!showOldPassword)}
            >
              {showOldPassword ? (
                <i className="bi bi-eye-fill"></i>
              ) : (
                <i className="bi bi-eye-slash"></i>
              )}
            </button>
          </div>
        </div>

        {/* New Password Field */}
        <div className="mt-3 m-lg-2">
          <label htmlFor="newPassword">New Password</label>
          <div className="input-group">
            <input
              type={showNewPassword ? 'text' : 'password'}
              className="form-control"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {showNewPassword ? (
                <i className="bi bi-eye-fill"></i>
              ) : (
                <i className="bi bi-eye-slash"></i>
              )}
            </button>
          </div>
        </div>

        {/* Submit Button */}
        <div className="mt-3 m-lg-2 text-end ">
          <button
            type="submit"
            className="btn btn-primary mt-3 mb-2  "
            disabled={loaded}
          >
            {loaded ? (
              <>
                <span
                  className="spinner-border spinner-border-sm "
                  role="status"
                  aria-hidden="true"
                ></span>{' '}
                Wait...
              </>
            ) : (
              <>Change Password</>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Changepassword;
